/**
 * 학원 목록 추천 배너로 지점 상세에 들어왔을 때 보여 주는 "학원 가기 전 추천 요금제".
 *
 * 문구(추천 대상·요금제명·설명)만 여기서 관리하고, 가격·태그는 요금 API(/v1/pricing)에서
 * `planCode`로 찾아 붙인다 — 코드에 두면 요금제 변경 시 화면이 어긋난다.
 * 면허 요금은 면허 종류별로 가격이 달라 price.label(아래 탭 값)로 고른다.
 * 단, API에 태그가 없는 요금제는 `tags`를 기본 태그로 보여 준다(API에 태그가 생기면 API가 우선).
 */
export interface RecommendedPlan {
  /** 요금 API plan.code */
  planCode: string;
  /** 추천 대상 */
  target: string;
  /** 요금제명(화면 표기) */
  title: string;
  description: string;
  /** 대표 추천(BEST) 표기 — 카드를 옅은 노란색으로 강조한다 */
  isBest?: boolean;
  /** API 요금제에 태그가 없을 때 보여 줄 기본 태그 */
  tags?: string[];
}

/** 면허 종류 탭. 요금 API price.label 과 같은 표기여야 가격이 붙는다. */
export const LICENSE_TYPE_TABS = [
  '2종 보통(자동)',
  '1종 보통(자동)',
  '1종 보통(수동)',
] as const;

export type LicenseTypeLabel = (typeof LICENSE_TYPE_TABS)[number];

export const RECOMMENDED_PLANS: RecommendedPlan[] = [
  {
    planCode: 'time_1hour',
    target: '학원 가기 전, 감부터 잡고 싶은 분께 추천',
    title: '1시간 이용반',
    isBest: true,
    description:
      '학원 등록 전에 시뮬레이터로 기기 조작과 기본 주행 감각을 가볍게 먼저 익혀 보세요.',
    // 커리큘럼 '기본 주행 교육' 항목 기반(운전연수 2시간 이용반 태그와 겹치지 않게)
    tags: ['브레이크·엑셀 감', '차체감 익히기', '핸들 조작', '좌·우회전'],
  },
  {
    planCode: 'time_2hour',
    target: '학원 연습만으로는 부족한 분께 추천',
    title: '2시간 이용반',
    description:
      '학원 교육 시간만으로 모자란 장내기능·도로주행 연습을 원하는 시간에 채워 보세요.',
    // 커리큘럼 '기초 조작 능력 교육'의 1종 수동 항목과 '시내주행' 항목 기반
    tags: ['클러치·변속기', '신호 이해', '차선 변경', '교차로 우회전'],
  },
];
